(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .constant('SHOWCASE_LAYOUT_TEMPLATE_CONSTANTS', {
            STATUS: {
                DRAFT: 'DRAFT',
                READY: 'READY'
            },
            COMPONENT_KEYS: {
                PRODUCTS_HORIZONTAL: 'PRODUCTS_HORIZONTAL',
                BRANDS_HORIZONTAL: 'BRANDS_HORIZONTAL',
                BANNER_CAROUSEL: 'BANNER_CAROUSEL'
            },
            /**
             * Catálogo seed public.view_component (fallback dev; produção usa GET /view-component).
             * has_value=true → exige JSON em value (filtros de produto).
             */
            VIEW_COMPONENT_CATALOG: [
                { id: 2, key: 'PRODUCTS_HORIZONTAL', hasValue: true },
                { id: 4, key: 'BRANDS_HORIZONTAL', hasValue: false },
                { id: 5, key: 'BANNER_CAROUSEL', hasValue: true }
            ],
            PRODUCT_FILTER_FIELDS: ['isLaunch', 'isBasic', 'categoryKeys', 'brands', 'gender'],
            DELETE_IN_USE_API_MESSAGE: 'Layout template cannot be deleted while it is associated with a showcase'
        });

})();
